import router from "@/services/Router";

export class EsquireClient {
  private baseUrl = process.env.VUE_APP_ESQUIRE_HOST;

  private defaultHeaders: HeadersInit = {
    Accept: "application/json"
  };

  public callcenterUrl(options: {
    path?: "login" | "logout";
    query?: Record<string, string>;
  } = {}): URL {
    if (!this.baseUrl) {
      throw new Error("VUE_APP_ESQUIRE_HOST is not configured");
    }

    const endpoint = options.path
      ? `/api/v1/callcenter/${options.path}`
      : "/api/v1/callcenter";
    const url = new URL(endpoint, this.baseUrl);

    Object.entries(options.query ?? {}).forEach(([key, value]) => {
      url.searchParams.set(key, value);
    });

    return url;
  }

  public async fetch(url: URL, options: RequestInit = {}): Promise<Response> {
    const headers = new Headers(this.defaultHeaders);
    new Headers(options.headers).forEach((value, key) => headers.set(key, value));

    const fetchOptions: RequestInit = {
      ...options,
      headers,
      credentials: "include"
    };

    return fetch(url.toString(), fetchOptions);
  }

  public async fetchAuthenticated(url: URL, options: RequestInit = {}): Promise<Response> {
    const response = await this.fetch(url, options);
    await this.logOutIfUnauthorized(response.status);
    return response;
  }

  public async isSuccessResponse(response: Response): Promise<boolean> {
    if (!response.ok) return false;

    try {
      return await response.json() === "success";
    } catch {
      return false;
    }
  }

  public async logOutIfUnauthorized(status: number): Promise<void> {
    if (status === 401) await this.logOut();
  }

  public async logOut(): Promise<void> {
    sessionStorage.removeItem("callcenterAuthenticated");
    localStorage.clear();
    await router.routeTo("auth");
  }
}

export default new EsquireClient();
